import { ProctorRequestCreationFormLogic } from '@exam-center/proctor-request-creation';

export default function ProctorRequestCreationPage() {
  return <ProctorRequestCreationFormLogic />;
}
